import React, { useEffect, useRef, useState } from 'react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import './App.css';
import useUTMParams from './useUTMParams';

const betterCalendlyURL = 'https://calendly.com/d/d56-qkn-h6z/better?hide_event_type_details=1&month=2026-05';

const toCalendlyParams = parentUrlParams => ({
    utmCampaign: parentUrlParams.get('utmCampaign') || parentUrlParams.get('utm_campaign'),
    utmSource: parentUrlParams.get('utmSource') || parentUrlParams.get('utm_source'),
    utmTerm: parentUrlParams.get('utmTerm') || parentUrlParams.get('utm_term'),
    utmMedium: parentUrlParams.get('utmMedium') || parentUrlParams.get('utm_medium'),
    utmContent: parentUrlParams.get('utmContent') || parentUrlParams.get('utm_content'),
    utmId: parentUrlParams.get('utmId') || parentUrlParams.get('utm_id')
});

const App = () => {
    const calendlyRef = useRef(null);
    const [stylingParams, setStylingParams] = useState({});
    const { ready, parentUrlParams, utmParams, clickIds, ipAddress, originalUrl } = useUTMParams();
    const calendlyParams = toCalendlyParams(parentUrlParams);

    const getStylingParams = () => {
        const iFrameUrl = new URL(window.location.href);
        const iFrameUrlParams = new URLSearchParams(iFrameUrl.search);
        const stylingParams = {
            width: iFrameUrlParams.get('width'),
            height: iFrameUrlParams.get('height')
        };
        setStylingParams(stylingParams);
    };

    const onEventScheduled = e => {
        console.log('calendlyEventScheduled');
        window.parent.postMessage('calendlyEventScheduled', 'https://go.allbetter.co.il');
        window.parent.postMessage('calendlyEventScheduled', 'https://round-table.co.il');
        window.parent.postMessage('calendlyEventScheduled', 'https://convetwiz.com');
        window.parent.postMessage('calendlyEventScheduled', 'https://channel22.co.il');
    };

    const onDateAndTimeSelected = e => {
        console.log('calendlyDateAndTimeSelected');
        // window.parent.postMessage(
        //   "calendlyDateAndTimeSelected",
        //   "https://go.allbetter.co.il"
        // );

        const iframe = document.getElementsByTagName('iframe')[0];
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        // alert("calendlyDateAndTimeSelected", iframe);
        // console.log(iframe);
        let style = document.createElement('style');
        // style.type = 'text/css';
        style.innerHTML = 'data-container=[details] {' + 'display:none' + '}';
        iframeDoc.head.appendChild(style);
    };

    useCalendlyEventListener({ onEventScheduled });

    useEffect(() => {
        getStylingParams();
    }, []);

    const getStyles = () => {
        return { ...stylingParams, overflow: 'hidden' };
    };

    const containerStyles = {
        width: addUnits(stylingParams.width, 10),
        height: addUnits(stylingParams.height, 10)
    };

    return (
        <div className="calenldy-iframe" id="calendly-iframe" style={containerStyles}>
            {/* Calendly reloads whenever its URL changes, so it is rendered only once the tracking data is in. */}
            {!ready ? (
                <div className="calendly-inline-widget" style={getStyles()}>
                    <div className="calendly-spinner">
                        <div className="calendly-bounce1" />
                        <div className="calendly-bounce2" />
                        <div className="calendly-bounce3" />
                    </div>
                </div>
            ) : (
                <InlineWidget
                    ref={calendlyRef}
                    url={betterCalendlyURL}
                    styles={getStyles()}
                    pageSettings={{
                        backgroundColor: 'ffffff',
                        hideEventTypeDetails: false,
                        hideLandingPageDetails: false,
                        hideGdprBanner: true,
                        primaryColor: '00a2ff',
                        textColor: '4d5055'
                    }}
                    utm={{
                        // Real UTMs from the parent page ride Calendly's utm params as-is (new
                        // tracking protocol). Calendly has no utm fields for utm_id/click ids, so
                        // they travel in the salesforce_uuid JSON, parsed back by the webhook.
                        utmCampaign: calendlyParams.utmCampaign,
                        utmSource: calendlyParams.utmSource,
                        utmTerm: calendlyParams.utmTerm,
                        utmMedium: calendlyParams.utmMedium,
                        utmContent: calendlyParams.utmContent,
                        salesforce_uuid: JSON.stringify({
                            protocolVersion: 2,
                            utmId: calendlyParams.utmId || utmParams.utm_id,
                            fbclid: clickIds.fbclid,
                            gclid: clickIds.gclid,
                            fbc: clickIds.fbc,
                            ipAddress,
                            originalUrl
                        })
                    }}
                />
            )}
        </div>
    );
};
export default App;

function addUnits(value, increment) {
    if (!value) return '100%';

    const match = value.match(/^(\d+)([a-z%]*)$/i);
    if (!match) return value;

    const number = parseInt(match[1], 10);
    const unit = match[2] || 'px'; // default to px if no unit is found

    return `${number + increment}${unit}`;
}
